import styled, { css } from 'styled-components'
import { Button, contentColorStyle } from './button'

type TertiaryButtonType = 'default' | 'negative'

const typeStyles = {
    default: css`
        ${(p) => contentColorStyle(p.theme.colors.primary.default)}

        &:hover {
            ${(p) => contentColorStyle(p.theme.colors.primary.green700)}
        }

        &:active {
            ${(p) => contentColorStyle(p.theme.colors.primary.green900)}
        }
    }
    `,
    negative: css`
        ${(p) => contentColorStyle(p.theme.colors.primaryRed)}

        &:hover {
            ${(p) => contentColorStyle(p.theme.colors.primaryRed)}
        }

        &:active {
            ${(p) => contentColorStyle(p.theme.colors.primaryRed)}
        }
    `,
}

export const TertiaryButton = styled(Button)<{ $type?: TertiaryButtonType }>`
    background-color: transparent;
    border: unset;
    text-decoration: underline;

    &:hover {
        border: unset;
    }

    &:active {
        border: unset;
    }

    &:disabled {
        border: unset;
    }

    ${(props) => typeStyles[props.$type ?? 'default']}
`
